import { User } from "@/app/auth/auth";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { FC } from "react";
import { classNames } from "@/shared/utils/classnames";
import { useTranslation } from "react-i18next";
import { toasts } from "@/shared/utils/toasts";

export type PersonalListItemProps = JSX.IntrinsicElements["li"] & {
  user?: User;
  isLoading?: boolean;
  onCalendar?: () => void;
  onDetails?: () => void;
  onResetPassword?: () => void;
  onActivate?: () => void;
  onEdit?: () => void;
  onLogIn?: () => void;
};

export const PersonalListItem: FC<PersonalListItemProps> = ({
  user,
  isLoading,
  onCalendar,
  onDetails,
  onResetPassword,
  onActivate,
  onEdit,
  onLogIn,
  ...props
}) => {
  const [t] = useTranslation();

  const handleGoWhatsapp = () => {
    if (!user.phone) {
      toasts.warning(
        "No pudimos abrir WhatsApp",
        "No hay número de WhatsApp disponible"
      );

      return;
    }

    window.open(
      `https://wa.me/57${user.phone}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <li
      key={user?.email}
      className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow flex flex-col relative border-t-0"
      {...props}
    >
      <span
        className={classNames(
          "absolute inline-flex rounded-full h-4 w-4",
          user?.active == 1 ? "bg-green-500" : "bg-gray-300"
        )}
        style={{ top: "-0.25rem", left: "-0.25rem" }}
      ></span>
      <div className="flex flex-1 w-full p-4 gap-4">
        {isLoading ? (
          <div className="h-10 w-10 bg-gray-300 animate-pulse rounded-md" />
        ) : (
          <img
            alt=""
            src={user?.avatar}
            className="h-10 w-10 flex-shrink-0 rounded-md bg-gray-300"
          />
        )}
        <div className="flex-1 truncate">
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
              {isLoading ? (
                <div className="w-full bg-gray-300 animate-pulse rounded-sm h-4 my-2" />
              ) : (
                <>
                  <h3
                    className="truncate text-sm font-medium text-gray-900 hover:text-primary-500 cursor-pointer"
                    onClick={onDetails}
                  >
                    {`${user?.name}`}
                  </h3>
                </>
              )}
              {/* 
              {!isLoading && (
                <Menu>
                  <MenuButton className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
                    <span className="sr-only"></span>
                    <FontAwesomeIcon
                      icon={faEllipsisVertical}
                      aria-hidden="true"
                      className="h-4 w-4"
                    />
                  </MenuButton>
                  <MenuItems
                    anchor="bottom end"
                    className="absolute right-0 z-10 mt-3 w-40 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                  >
                    {onEdit && (
                      <MenuItem>
                        <a
                          onClick={onEdit}
                          className="block px-4 py-2 text-sm text-primary-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          role="button"
                        >
                          Editar
                        </a>
                      </MenuItem>
                    )}
                    {onResetPassword && (
                      <MenuItem>
                        <a
                          onClick={onResetPassword}
                          className="block px-4 py-2 text-sm text-primary-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          role="button"
                        >
                          Reiniciar contraseña
                        </a>
                      </MenuItem>
                    )}
                    {onActivate && (
                      <MenuItem>
                        <a
                          onClick={onActivate}
                          className="block px-4 py-2 text-sm text-red-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          role="button"
                        >
                          {user?.active == 1
                            ? t("general.deactivate")
                            : t("general.activate")}
                        </a>
                      </MenuItem>
                    )}
                    {onLogIn && (
                      <MenuItem>
                        <a
                          onClick={onLogIn}
                          className="block px-4 py-2 text-sm text-red-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          role="button"
                        >
                          {t("general.login")}
                        </a>
                      </MenuItem>
                    )}
                    {user?.role == "Coach" && (
                      <MenuItem>
                        <a
                          onClick={onCalendar}
                          className="block px-4 py-2 text-sm text-red-500 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          role="button"
                        >
                          {t("general.calendar")}
                        </a>
                      </MenuItem>
                    )}
                  </MenuItems>
                </Menu>
              )}
              */}
            </div>
            {isLoading ? (
              <div className="w-3/4 bg-gray-300 animate-pulse rounded-sm h-3" />
            ) : user?.role ? (
              <h3 className="truncate text-xs font-medium text-gray-900">
                {t(`roles.${user?.role}`)}
              </h3>
            ) : null}

            {/*
              {isLoading ? (
                <div className="w-2/4 bg-gray-300 animate-pulse rounded-sm h-3" />
              ) : (
                <small className="truncate text-xs text-gray-500">
                  {DateTime.fromISO(user?.createdAt)
                    .setLocale(i18n.language)
                    .toRelativeCalendar()}
                </small>
              )}
            */}
          </div>
        </div>
      </div>
      <div>
        <div className="flex divide-x divide-gray-200">
          <div className="flex w-0 flex-1">
            {isLoading ? (
              <div className="h-10 py-2 relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent text-sm font-semibold text-gray-900">
                <div className="w-3/4 bg-gray-300 animate-pulse rounded-sm h-3" />
              </div>
            ) : (
              <a
                href={`mailto:${user?.email}`}
                className="h-10 py-2 relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent text-sm font-semibold text-gray-900"
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="h-4 w-4 text-gray-400"
                />
                {t("forms.label.email")}
              </a>
            )}
          </div>
          <div className="-ml-px flex w-0 flex-1">
            {isLoading ? (
              <div className="h-10 py-2 relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent text-sm font-semibold text-gray-900">
                <div className="w-3/4 bg-gray-300 animate-pulse rounded-sm h-3" />
              </div>
            ) : (
              <button
                onClick={handleGoWhatsapp}
                className="h-10 py-2 relative inline-flex w-0 flex-1 items-center justify-center gap-x-1 rounded-br-lg border border-transparent text-sm font-semibold text-gray-900 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-gray-200"
                disabled={!user?.phone}
              >
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  className="h-4 w-4 text-gray-400"
                />
                {t("forms.label.whatsapp")}
              </button>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};
